module.exports = __webpack_public_path__ + "static/media/number-item-6.15639d6e.png";